import { auditLogsPath } from '../../admin/components/admin-paths';

const BASE_ROUTE = `/admin${auditLogsPath}`;

export const auditLogsRoute = BASE_ROUTE;
